import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { MerchantRegistrationFormComponent } from './components/merchant-registration-form/merchant-registration-form.component';
import { MerchantRegistrationRoutingModule } from './merchant-registration-routing.module';
import { MerchantRegistrationComponent } from './merchant-registration/merchant-registration.component';

@NgModule({
  declarations: [
    MerchantRegistrationFormComponent,
    MerchantRegistrationComponent,
  ],
  exports: [MerchantRegistrationComponent, MerchantRegistrationFormComponent],
  imports: [CommonModule, MerchantRegistrationRoutingModule, SharedModule],
})
export class MerchantRegistrationModule {}
